<template>
  <div>
    <ContentHeader />

    <div class="content-container">
      <!-- 业务线 -->
      <el-row class="form-item">
        <el-col :span="3"><span class="required-text">*</span>业务线</el-col>
        <el-col :span="21">
          <el-radio-group v-model="tradeApplyInfoVO.clientType" class="radio-btn">
            <el-radio-button label="01">TMKT</el-radio-button>
            <el-radio-button label="02">ISP</el-radio-button>
            <el-radio-button label="03">KA</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>

      <!-- 渠道 -->
      <el-row class="form-item">
        <el-col :span="3"><span class="required-text">*</span>渠道</el-col>
        <el-col :span="21">
          <el-select v-model="tradeApplyInfoVO.channelCode" placeholder="请选择渠道" clearable filterable style="width: 370px">
            <el-option
              v-for="item in channelList"
              :label="item.channelName"
              :value="item.channelCode"
              :key="item.channelCode"
            />
          </el-select>
        </el-col>
      </el-row>

       <!-- Region -->
       <el-row class="form-item">
        <el-col :span="3"><span class="required-text">*</span>Region</el-col>
        <el-col :span="21">
          <el-select v-model="tradeApplyInfoVO.regionCode" placeholder="请选择Region" clearable filterable style="width: 370px">
            <el-option
            v-for="(item, index) in regionOrgList"
              :key="index"
              :label="item.orgName"
              :value="item.orgCode"
            />
          </el-select>
        </el-col>
      </el-row>


      <el-row class="form-item">
        <!-- 活动主题 -->
        <el-col :span="3"><span class="required-text">*</span>活动主题</el-col>
        <el-col :span="10">
          <el-input placeholder="请填写活动主题" style="width: 370px" v-model="tradeApplyInfoVO.eventSubject" ></el-input>
        </el-col>
        <!-- 预计投入门店数量 -->
        <el-col :span="3"><span class="required-text">*</span>预计投入门店数量</el-col>
        <el-col :span="8">
          <el-input-number v-model="tradeApplyInfoVO.estimatePocQty" :min="0" label="门店数量"></el-input-number>
        </el-col>
      </el-row>

      <!-- 物料 -->
      <TradeApplyMaterial :tradeBmApplyDetailList = "tradeBmApplyDetailList"/>

      <el-row class="form-item">
        <!-- 供应商 -->
        <el-col :span="3"><span class="required-text">*</span>供应商</el-col>
        <el-col :span="10">
          <el-select v-model="tradeApplyInfoVO.vendorId" placeholder="请选择供应商" clearable filterable style="width: 370px">
            <el-option
              v-for="item in supplierList"
              :label="item.supplierName"
              :value="item.supplierId"
              :key="item.supplierId"
            />
          </el-select>
        </el-col>
        <!-- 需求交货时间 -->
        <el-col :span="3"><span class="required-text">*</span>需求交货时间</el-col>
        <el-col :span="8">
          <el-date-picker
            v-model="tradeApplyInfoVO.deliveryDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            :picker-options="timeOptions" clearable
            size="middle"
            class="time-picker">
          </el-date-picker>
        </el-col>
      </el-row>

      <!-- 申报说明 -->
      <el-row class="form-item form-item-none">
        <el-col :span="3"><span class="required-text">*</span>申报说明</el-col>
        <el-col :span="21">
          <el-input type="textarea" rows="3" resize="none" placeholder="请填写批量化物料尺寸要求" v-model="tradeApplyInfoVO.applyDesc"></el-input>
        </el-col>
      </el-row>

      <!-- 示例图片 -->
      <el-row class="form-item form-item-none">
        <el-col :span="3">示例图片</el-col>
        <el-col :span="21">
          <el-upload
            ref="uploadCertificate"
            list-type="picture-card"
            accept="image/*"
            :limit="3"
            :action="fileUploadTarget"
            :headers="uploadHeaders"
            :on-success="handleUploadSuccess"
            :before-remove="handleFileRemove"
            :file-list="imageList">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-col>
      </el-row>

      <!-- 按钮 -->
      <div class="btn-fixed">
        <el-row class="submit-btn" type="flex" justify="center">
          <el-button type="primary" class="btn-blue-plain-hover" @click="resetApply">重置</el-button>
          <el-button type="primary" class="btn-blue-plain-hover" :loading="isApplying" @click="submitApply">提交</el-button>
        </el-row>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { tokenUtils } from '@/utils/auth'
import tradeApi from '@/api/trade'

import ContentHeader from '../../components/content-header'
import TradeApplyMaterial from './components/trade-apply-material'
export default {
  name: 'trade-apply',
  components: {
    ContentHeader,
    TradeApplyMaterial
  },
  data () {
    return {
      tradeApplyInfoVO: {
        applyType: '02',
        clientType: '', // 业务线 - 01百威、03KA
        channelCode: '',
        eventSubject: '',
        vendorId: '',
        applyDesc: '',
        deliveryDate: '',
        estimatePocQty: null,
        orgCode:''
      },
      tradeBmApplyDetailList: [
        {
          itemName: '',
          itemQty: 1,
          subBrandCode: '',
          brandGroup: ''
        }
      ],
      tradeBmApplyImageList: [],
      channelList: [],
      supplierList: [],
      timeOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      imageList: [],
      isApplying: false,
      regionOrgList:[],
    }
  },
  computed: {
    ...mapState({
      fileUploadTarget: state => state.app.fileUploadTarget
    }),
    uploadHeaders () {
      return {
        Authorization: 'Bearer ' + tokenUtils.getToken(true),
        Accept: 'application/json'
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getChannel()
      this.getSupplier()
      this.getRegionOrgList()
    },

    // 获取渠道
    getChannel () {
      this.$store.dispatch('getChannel').then(res => {
        if (res.data.resultCode === '0') {
          if (res.data.resultData.baseChannelVOList) {
            res.data.resultData.baseChannelVOList.forEach(item => {
              this.channelList.push(item.parentBaseChannel)
            })
          }
        }
      })
    },

    // 获取供应商
    getSupplier () {
      let params = {
        vendorName: ''
      }
      this.$store.dispatch('getSupplier', params).then(res => {
        if (res.data.resultCode === '0') {
          this.supplierList = res.data.resultData.vendorList
        }
      })
    },

    // 上传图片
    handleUploadSuccess (res, file) {
      if (res.resultCode === '0') {
        this.imageList.push(file)
        this.tradeBmApplyImageList.push({
          imageUri: res.resultData.fileDTO.fileUri,
          imageId: res.resultData.fileDTO.fileId
        })
      } else {
        this.$message.error({ message: res.resultMsg, showClose: true })
        this.imageList.pop()
      }
    },

    // 删除图片
    handleFileRemove (file) {
      if (file) {
        this.$store.dispatch('deleteFile', { fileId: file.response.resultData.fileDTO.fileId }).then((res) => {
          if (res.data.resultCode === '0') {
            this.imageList.forEach((item, index) => {
              if (item.uid === file.uid) {
                this.imageList.splice(index, 1)
                this.tradeBmApplyImageList.splice(index, 1)
              }
            })
          }
        })
      }
    },

    // 重置
    resetApply () {
      this.tradeApplyInfoVO = {
        applyType: '02',
        clientType: '',
        channelCode: '',
        eventSubject: '',
        vendorId: '',
        applyDesc: '',
        deliveryDate: '',
        estimatePocQty: null
      }
      this.tradeBmApplyDetailList = [
        {
          itemName: '',
          itemQty: 1,
          subBrandCode: '',
          brandGroup: ''
        }
      ]
      this.imageList = []
      this.tradeBmApplyImageList = []
    },

    // 数据验证
    checkData () {
      if (!this.tradeApplyInfoVO.clientType) {
        this.$message.error('请选择业务线')
        return false
      }
      if (!this.tradeApplyInfoVO.channelCode) {
        this.$message.error('请选择渠道')
        return false
      }
      if (!this.tradeApplyInfoVO.regionCode) {
        this.$message.error('请选择Region')
        return false
      }
      if (!this.tradeApplyInfoVO.eventSubject) {
        this.$message.error('请填写活动主题')
        return false
      }
      if (!this.tradeApplyInfoVO.estimatePocQty) {
        this.$message.error('请填写预计投入门店数量')
        return false
      }
      if (!this.tradeApplyInfoVO.vendorId) {
        this.$message.error('请选择供应商')
        return false
      }
      if (!this.tradeApplyInfoVO.deliveryDate) {
        this.$message.error('请选择需求交货时间')
        return false
      }
      if (!this.tradeApplyInfoVO.applyDesc) {
        this.$message.error('请填写申报说明')
        return false
      }

      let hasIncomplete = this.tradeBmApplyDetailList.filter(item => {
        return !item.itemName || !item.itemQty || !item.subBrandCode
      })
      if (hasIncomplete.length) {
        this.$message.error('物料信息填写不完整')
        return false
      }

      let hasDifferent = new Set(this.tradeBmApplyDetailList.map(
        item => item.brandGroup
      )).size
      if (hasDifferent !== 1) {
        this.$message.error('不同品牌组的物料无法同时下单')
        return false
      }

      return true
    },

    // 提交
    submitApply () {
      if (this.isApplying) {
        return
      }

      if (!this.checkData()) {
        return false
      }
      let data = {
        tradeApplyInfoVO: this.tradeApplyInfoVO,
        tradeBmApplyDetailList: this.tradeBmApplyDetailList,
        tradeBmApplyImageList: this.tradeBmApplyImageList
      }
      this.isApplying = true
      this.$store.dispatch('submitBatch', data).then(res => {
        this.isApplying = false
        if (res.data.resultCode === '0') {
          this.$router.replace({
            path: '/trade/trade-apply-success',
            query: {
              applyNumber: res.data.resultData.applyNumber,
              applyId: res.data.resultData.applyId
            }
          })
        }
      }).catch(() => {
        this.isApplying = false
      })
    },

     // region 区域列表
     getRegionOrgList() {
      tradeApi.getAllRegionList().then(res => {
        if (res.data.resultCode === '0') {
          const { regionList } = res.data.resultData
          this.regionOrgList = regionList.filter(item => {
            return item.orgType === '03'
          })
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.content-container {
  padding-bottom: 0;
}

.form-item {
  padding: $content-large;
  line-height: 40px;
}

.form-item-none {
  line-height: 20px;
}

::v-deep .el-upload--picture-card,
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 120px;
  height: 120px;
}

::v-deep .el-upload--picture-card {
  line-height: 120px;
}

.btn-fixed {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 10;
  margin-left: calc(600px - 50%);
  background-color: #f3f5f9;

  .submit-btn {
    margin: 32px 0;
    text-align: center;
    .el-button {
      width: 180px;
      margin: 0 20px;
    }
  }
}
</style>
